"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const General_1 = require("../../types/General");
const callableStringInterpolation = ({ entryVars: { [General_1.DEFINITION_PROP_NAMES.INTERPOLATION]: interpolation, }, }) => interpolation;
exports.default = callableStringInterpolation;
